<template>
  <div class="tw-my-8">
    <WdsAlert v-if="errorMessage" error icon>
      {{ $t('An error occurred') }}
      <template #description>
        {{ errorMessage }}
        <div class="tw-mt-2">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <WdsButtonText href="/">
            {{ $t('Go to dashboard') }}
          </WdsButtonText>
        </div>
      </template>
    </WdsAlert>
    <WdsAlert v-else-if="compliances.length === 0" info icon>
      {{ $t('We did not find any compliance settings applicable to your account.') }}
      <template #description>
        <div class="tw-mt-2">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <WdsButtonText href="/">
            {{ $t('Go to dashboard') }}
          </WdsButtonText>
        </div>
      </template>
    </WdsAlert>
    <template v-else>
      <template v-for="(compliance, i) in compliances">
        <WdsDivider v-if="i > 0" :key="i" class="tw-my-8" />

        <SettingsPageSection
          v-if="compliance.name === 'EMPLOYMENT_COST'"
          :key="compliance.name"
          title="Employment cost preference"
        >
          <template #subtitle>
            <WdsText secondary>
              When a hire is determined as being
              <em>Inside IR35</em>
              or
              <em>Fixed term - PAYE</em>
              , there will be additional taxes applied.
            </WdsText>

            <WdsText secondary class="tw-mt-2">
              You can set your preference for how those taxes will be paid here.
            </WdsText>
          </template>

          <EmploymentCostSettingsForm :company="company" :compliance-data="compliance.data" />
        </SettingsPageSection>

        <SettingsPageSection
          v-else-if="compliance.name === 'IR35_COMPANY_SETTINGS'"
          :key="compliance.name"
          title="IR35"
        >
          <template #subtitle>
            <span class="small">
              <a
                href="https://help.worksome.dk/en/articles/3669319-worksome-s-ir35-guide-for-employers"
                target="_blank"
                class="underline"
              >
                Learn about April 2021 changes to off-payroll working for clients
              </a>
            </span>
          </template>

          <Ir35CompanySettingsForm :company="company" :compliance-data="compliance.data" />
        </SettingsPageSection>

        <SettingsPageSection
          v-else-if="compliance.name === 'UK_SOLE_TRADER'"
          :key="compliance.name"
          title="Sole Trader engagement"
        >
          <template #subtitle></template>
          <UkSoleTraderSettingsForm :company="company" :compliance-data="compliance.data" />
        </SettingsPageSection>

        <SettingsPageSection
          v-else-if="compliance.name === 'UK_STATEMENT_OF_WORK'"
          :key="compliance.name"
          title="Statement of Work (SOW) contract type"
        >
          <template #subtitle>
            <WdsText secondary>
              An SOW is a document that details the specifics of an outsourced piece of work and is
              used to reflect it is a fully contracted-out service. The supplier is engaged to
              manage and deliver a project(s) under clear outcomes and deliverables upon a strict
              budget.
            </WdsText>

            <WdsText secondary class="tw-mt-2">
              This should not be confused with a traditional supply of labour contract, which would
              dictate the number of personnel required and is usually remunerated for time and
              materials spent.
            </WdsText>
          </template>

          <UkStatementOfWorkSettingsForm :company="company" :compliance-data="compliance.data" />
        </SettingsPageSection>
      </template>
    </template>
  </div>
</template>

<script>
import { WdsAlert, WdsDivider, WdsText } from '@worksome/wds-components'

import EmploymentCostSettingsForm from '@/components/compliances/settings/EmploymentCostSettingsForm.vue'
import Ir35CompanySettingsForm from '@/components/compliances/settings/Ir35CompanySettingsForm.vue'
import SettingsPageSection from '@/components/compliances/settings/SettingsPageSection.vue'
import UkSoleTraderSettingsForm from '@/components/compliances/settings/UkSoleTraderSettingsForm.vue'
import UkStatementOfWorkSettingsForm from '@/components/compliances/settings/UkStatementOfWorkSettingsForm.vue'
import { FormValidation } from '@/utils/formValidation'

export default {
  components: {
    EmploymentCostSettingsForm,
    Ir35CompanySettingsForm,
    SettingsPageSection,
    UkSoleTraderSettingsForm,
    UkStatementOfWorkSettingsForm,
    WdsAlert,
    WdsDivider,
    WdsText,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    compliances: {
      type: Array,
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    errorMessage() {
      return FormValidation.containsErrorMessage(this.errors)
    },
  },
}
</script>
